import { createSelector } from 'reselect';

export function getCurrentSiteUser(state) {
  return state.currentSiteUser;
}

export const getCurrentUserEmail = createSelector(
  getCurrentSiteUser,
  currentSiteUser => _.get(currentSiteUser, 'email', ''),
);
